import PreCSS from "../src/utils/preRenderCSS";
import { useEffect, useState } from "react";
import Head from "next/head";

import Interweave from "interweave";
import { parseInfo } from "../src/utils";
import useWindowSize from "../src/utils/useWindowSize";

import { Dialog } from "@material-ui/core";
import {
  DecorationLine,
  TopContentsTitleContainer,
  TopContentsTitle,
  TopContentsContainer,
} from "../src/components/style";
import {
  SupportContainer,
  ItemImage,
  ItemTitle,
  SupportMain,
  SupportTitle,
  SupportIntro,
  SupportItemWrapper,
  SupportItem,
  ItemImageButton,
  ItemImageAlt,
  ItemDescription,
  ItemBody,
  WebButton,
  WebButtonWrapper,
} from "../src/components/style/support";

import { support } from "../src/config/Support";
import { contact } from "../src/config/Contact";
import EmailButton from "../src/components/EmailButton";

function Support({ lang }: { lang: string }) {
  const windowSize = useWindowSize();

  const isWindowClient = typeof window === "object";

  const [check, setCheck] = useState(false);

  const [size, setSize] = useState(
    isWindowClient ? window.innerWidth : undefined
  );

  useEffect(() => {
    function defineSize() {
      setSize(window.innerWidth);
      setCheck(false);
    }

    if (isWindowClient) {
      window.addEventListener("resize", defineSize, { passive: true });

      return () => window.removeEventListener("resize", defineSize);
    }
  }, [isWindowClient, setSize]);

  useEffect(() => {
    if (!check) {
      const id = global.setInterval(() => {
        const pics = document.getElementsByClassName("pic");
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < pics.length; i++) {
          const pic = pics[i] as HTMLElement;
          if (pic) {
            pic.style.height = `${(pic.clientWidth * 2) / 3}px`;
          }
        }

        // TODO: if no pic this wont work
        if (pics.length) {
          setCheck(true);
          clearInterval(id);
        }
      }, 100);
    }
  }, [check, size]);

  const [open, setOpen] = useState(false);
  const [modalImg, setModalImg] = useState("");
  const [selected, setSelected] = useState("");
  const openDialog = (img: string) => {
    setOpen(true);
    setModalImg(img);
  };
  const handleClose = () => {
    setOpen(false);
    setModalImg("");
    setSelected(selected);
  };

  return (
    <div>
      <PreCSS />
      <Head>
        <title>zerO サポート</title>
        <meta property="og:title" content="zerO サポート" />
        <meta
          property="og:description"
          content="zerO をサポートされる方々について"
        />
        <meta property="og:image" content="/assets/logoShare.jpg" />
        <meta property="og:url" content="https://zero-dance.com/support/" />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="profile_pic"
        maxWidth="lg"
      >
        <img
          src={modalImg}
          alt="modal"
          onContextMenu={(e) => {
            e.preventDefault();
            return false;
          }}
          style={{
            objectFit: "contain",
            width: "100%",
          }}
        />
      </Dialog>

      <SupportContainer>
        <TopContentsContainer>
          {windowSize === "desktop" ? (
            <div style={{ position: "fixed", display: "flex" }}>
              <TopContentsTitleContainer>
                <TopContentsTitle>support</TopContentsTitle>
              </TopContentsTitleContainer>
              <DecorationLine />
            </div>
          ) : windowSize === "mobile" || windowSize === "tablet" ? (
            <>
              <div
                style={{
                  fontSize: "18px",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontWeight: 400,
                }}
              >
                support
              </div>
              <DecorationLine />
            </>
          ) : (
            <p></p>
          )}

          <SupportMain>
            <SupportTitle>
              <Interweave
                content={parseInfo(
                  lang === "ja"
                    ? support.title.ja
                    : lang === "en"
                    ? support.title.en
                    : ""
                )}
              />
            </SupportTitle>
            <SupportIntro>
              <Interweave
                content={parseInfo(
                  lang === "ja"
                    ? support.intro.ja
                    : lang === "en"
                    ? support.intro.en
                    : ""
                )}
              />
              <EmailButton
                email={contact.emailAddress}
                subject={contact.email.subject}
                body={contact.email.body}
                lang={lang}
              />
            </SupportIntro>
            {lang ? (
              support.items.length ? (
                <SupportItemWrapper container spacing={5}>
                  {support.items.map((item, i) => {
                    const itemContents = () => (
                      <>
                        {item.image ? (
                          <ItemImageButton aria-label="main image">
                            <ItemImage
                              src={item.image}
                              alt={item.title.ja}
                              onContextMenu={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              className="pic"
                              onClick={() => openDialog(item.image)}
                            />
                          </ItemImageButton>
                        ) : (
                          <ItemImageAlt />
                        )}
                        <ItemDescription>
                          <ItemTitle>
                            <Interweave
                              content={parseInfo(
                                lang === "ja"
                                  ? item.title.ja
                                  : lang === "en"
                                  ? item.title.en
                                  : ""
                              )}
                            />
                          </ItemTitle>
                          <ItemBody className="textContainer">
                            <Interweave
                              content={parseInfo(
                                lang === "ja"
                                  ? item.body.ja
                                  : lang === "en"
                                  ? item.body.en
                                  : ""
                              )}
                            />
                          </ItemBody>
                        </ItemDescription>
                        <WebButtonWrapper>
                          <WebButton
                            onClick={() => window.open(item.link, "_blank")}
                            aria-label="web"
                          >
                            WEB
                          </WebButton>
                        </WebButtonWrapper>
                      </>
                    );

                    return windowSize === "desktop" ? (
                      <SupportItem item xs={6}>
                        {itemContents()}
                      </SupportItem>
                    ) : windowSize === "mobile" || windowSize === "tablet" ? (
                      <SupportItem item xs={12}>
                        {itemContents()}
                      </SupportItem>
                    ) : (
                      <p></p>
                    );
                  })}
                </SupportItemWrapper>
              ) : (
                <div>
                  {lang === "ja"
                    ? "表示する情報がありません。"
                    : "No item found."}
                </div>
              )
            ) : (
              <></>
            )}
          </SupportMain>
        </TopContentsContainer>
      </SupportContainer>
    </div>
  );
}

export default Support;
